<!-- Hero Section -->
<div class="min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50">
  <!-- Header -->
  <header class="bg-white/80 backdrop-blur-md border-b border-gray-200 sticky top-0 z-50">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex justify-between items-center py-4">
        <div class="flex items-center space-x-3">
          <a class="brand-logo">
            <img
              src="../../../../../assets/images/pages/logo_white.png"
              alt="Kingsschool Logo"
              height="28"
            />
          </a>
          <!-- <div>
            <h1 class="text-xl font-bold text-gray-900">Kingsschool</h1>
            <p class="text-xs text-gray-600">{{ 'ONLINE_ACCESS.FOOTER.PLATFORM' | translate }}</p>
          </div> -->
        </div>
        <div class="flex items-center space-x-3">
          <!-- Language Toggle -->
          <p-dropdown appendTo="body"
            [(ngModel)]="selectedLanguage"
            (onChange)="onLanguageChange()"
            [options]="languages"
            optionLabel="label"
            optionValue="value"
            styleClass="p-button-sm"
            [style]="{'height': '32px', 'min-width': '80px'}"
            appendTo="body"
          >
            <ng-template pTemplate="selectedItem" let-selectedOption>
              <span *ngIf="selectedOption" class="flex items-center">
                <i [class]="selectedOption.icon" class="mr-1"></i>
                {{ selectedOption.label | translate }}
              </span>
            </ng-template>
            <ng-template pTemplate="item" let-option>
              <span class="flex items-center">
                <i [class]="option.icon" class="mr-2"></i>
                {{ option.label | translate }}
              </span>
            </ng-template>
          </p-dropdown>
          
          <p-button
            label="{{ 'ONLINE_ACCESS.ADMIN_LOGIN' | translate }}"
            icon="pi pi-sign-in"
            styleClass="p-button-sm"
            [style]="{'height': '32px'}"
          ></p-button>
        </div>
      </div>
    </div>
  </header>

  <!-- Main Content -->
  <main class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
    <!-- Hero Section -->
    <div class="text-center mb-16">
      <h1 class="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
        {{ 'ONLINE_ACCESS.TITLE' | translate }}
      </h1>
      <p class="text-lg md:text-xl text-gray-600 mb-6 max-w-3xl mx-auto">
        {{ 'ONLINE_ACCESS.SUBTITLE' | translate }}
      </p>
      
      <!-- Search and Filter Bar -->
      <div class="max-w-3xl mx-auto">
        <div class="bg-white rounded-lg shadow-lg p-4 border border-gray-200">
          <div class="flex flex-col sm:flex-row gap-3">
            <!-- Search Input -->
            <div class="flex-1">
              <div class="relative">
                <i class="pi pi-search absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
                <input
                  type="text"
                  [(ngModel)]="searchQuery"
                  (input)="onSearchChange()"
                  [placeholder]="'ONLINE_ACCESS.SEARCH_PLACEHOLDER' | translate"
                  class="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all search-input"
                />
              </div>
            </div>
            
            <!-- School Type Filter -->
            <div class="sm:w-48">
              <p-dropdown appendTo="body"
                [(ngModel)]="selectedSchoolType"
                (onChange)="onTypeFilterChange()"
                [options]="schoolTypes"
                optionLabel="label"
                optionValue="value"
                placeholder="{{ 'ONLINE_ACCESS.FILTER_BY_TYPE' | translate }}"
                styleClass="w-full"
                [style]="{'height': '38px'}"
                appendTo="body"
              >
                <ng-template pTemplate="selectedItem" let-selectedOption>
                  <span *ngIf="selectedOption">{{ selectedOption.label | translate }}</span>
                </ng-template>
                <ng-template pTemplate="item" let-option>
                  <span>{{ option.label | translate }}</span>
                </ng-template>
              </p-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading State -->
    <div *ngIf="isLoading" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      <div *ngFor="let i of [1,2,3,4,5,6]" class="bg-white rounded-lg shadow-md p-4 border border-gray-200">
        <p-skeleton height="120px" class="mb-3"></p-skeleton>
        <p-skeleton height="18px" class="mb-2"></p-skeleton>
        <p-skeleton height="14px" class="mb-3"></p-skeleton>
        <p-skeleton height="36px"></p-skeleton>
      </div>
    </div>

    <!-- Schools Grid -->
    <div *ngIf="!isLoading" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      <div
        *ngFor="let school of filteredSchools; trackBy: trackBySchoolId"
        class="group bg-white rounded-lg shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1 border border-gray-200 overflow-hidden"
      >
        <!-- School Card -->
        <div class="relative">
          <!-- School Logo -->
          <div class="p-4 pb-3">
            <div class="flex items-center space-x-3 mb-3">
              <div class="w-12 h-12 rounded-lg overflow-hidden bg-gray-100 flex items-center justify-center">
                <img
                  [src]="school.logo"
                  [alt]="school.name + ' logo'"
                  class="w-full h-full object-cover"
                />
              </div>
              <div class="flex-1">
                <h3 class="text-lg font-bold text-gray-900 group-hover:text-blue-600 transition-colors">
                  {{ school.name }}
                </h3>
                <p-tag
                  [value]="getSchoolTypeLabel(school.type)"
                  [severity]="getSchoolTypeColor(school.type)"
                  styleClass="text-xs"
                ></p-tag>
              </div>
            </div>
            
            <!-- School Description -->
            <p class="text-gray-600 text-sm mb-3 line-clamp-2">
              {{ school.description || ('DEFAULT_SCHOOL_DESCRIPTION' | translate) }}
            </p>
            
            <!-- School Details -->
            <div class="space-y-1 mb-4">
              <div class="flex items-center text-xs text-gray-600">
                <i class="pi pi-map-marker text-blue-500 mr-2"></i>
                <span class="truncate">{{ school.address }}</span>
              </div>
              <div class="flex items-center text-xs text-gray-600">
                <i class="pi pi-envelope text-blue-500 mr-2"></i>
                <span class="truncate">{{ school.contact_email }}</span>
              </div>
              <div class="flex items-center text-xs text-gray-600">
                <i class="pi pi-phone text-blue-500 mr-2"></i>
                <span class="truncate">{{ school.contact_phone }}</span>
              </div>
            </div>
          </div>
          
          <!-- Action Button -->
          <div class="px-4 pb-4">
            <p-button
              (onClick)="navigateToRegistration(school)"
              [label]="'ONLINE_ACCESS.REGISTER_NOW' | translate"
              icon="pi pi-user-plus"
              styleClass="w-full p-button-sm"
              [style]="{'height': '36px'}"
            ></p-button>
          </div>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div *ngIf="!isLoading && filteredSchools.length === 0" class="text-center py-12">
      <div class="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
        <i class="pi pi-search text-2xl text-gray-400"></i>
      </div>
      <h3 class="text-xl font-bold text-gray-900 mb-3">{{ 'ONLINE_ACCESS.NO_SCHOOLS_FOUND' | translate }}</h3>
      <p class="text-gray-600 mb-6 max-w-md mx-auto">
        {{ 'ONLINE_ACCESS.NO_SCHOOLS_MESSAGE' | translate }}
      </p>
      <p-button
        (onClick)="searchQuery = ''; selectedSchoolType = 'ALL'; filterSchools()"
        [label]="'ONLINE_ACCESS.CLEAR_FILTERS' | translate"
        styleClass="p-button-sm"
        [style]="{'height': '36px'}"
      ></p-button>
    </div>
  </main>

  <!-- Footer -->
  <footer class="bg-gray-900 text-white py-8 mt-16">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="grid grid-cols-1 md:grid-cols-4 gap-6">
        <div class="col-span-1 md:col-span-2">
          <div class="flex items-center space-x-3 mb-3">
            <a class="brand-logo">
              <img
                src="../../../../../assets/images/pages/logo_white.png"
                alt="Kingsschool Logo"
                height="24"
              />
            </a>
            <div>
              <h3 class="text-lg font-bold">Kingsschool</h3>
              <p class="text-gray-400 text-xs">{{ 'ONLINE_ACCESS.FOOTER.PLATFORM' | translate }}</p>
            </div>
          </div>
          <p class="text-gray-400 mb-4 max-w-md text-sm">
            {{ 'ONLINE_ACCESS.FOOTER.DESCRIPTION' | translate }}
          </p>
        </div>
        
        <div>
          <h4 class="font-semibold mb-3 text-sm">{{ 'ONLINE_ACCESS.FOOTER.PLATFORM' | translate }}</h4>
          <ul class="space-y-1 text-gray-400 text-sm">
            <li><a href="#" class="hover:text-white transition-colors">{{ 'ONLINE_ACCESS.FOOTER.FEATURES' | translate }}</a></li>
            <li><a href="#" class="hover:text-white transition-colors">{{ 'ONLINE_ACCESS.FOOTER.PRICING' | translate }}</a></li>
            <li><a href="#" class="hover:text-white transition-colors">{{ 'ONLINE_ACCESS.FOOTER.DOCUMENTATION' | translate }}</a></li>
            <li><a href="#" class="hover:text-white transition-colors">{{ 'ONLINE_ACCESS.FOOTER.SUPPORT_LABEL' | translate }}</a></li>
          </ul>
        </div>
        
        <div>
          <h4 class="font-semibold mb-3 text-sm">{{ 'ONLINE_ACCESS.FOOTER.SUPPORT' | translate }}</h4>
          <ul class="space-y-1 text-gray-400 text-sm">
            <li><a href="#" class="hover:text-white transition-colors">{{ 'ONLINE_ACCESS.FOOTER.HELP_CENTER' | translate }}</a></li>
            <li><a href="#" class="hover:text-white transition-colors">{{ 'ONLINE_ACCESS.FOOTER.CONTACT_US' | translate }}</a></li>
            <li><a href="#" class="hover:text-white transition-colors">{{ 'ONLINE_ACCESS.FOOTER.STATUS' | translate }}</a></li>
            <li><a href="#" class="hover:text-white transition-colors">{{ 'ONLINE_ACCESS.FOOTER.COMMUNITY' | translate }}</a></li>
          </ul>
        </div>
      </div>
      
      <div class="border-t border-gray-800 mt-6 pt-6 text-center text-gray-400 text-sm">
        <p>{{ 'ONLINE_ACCESS.FOOTER.COPYRIGHT' | translate }}</p>
      </div>
    </div>
  </footer>
</div>
